import { useEffect, useState } from "react";
import "./advertisements.css";
import ViewQuillComponent from "../../../dashboard/admin/textos/viewQuillComponent";
import axios from "axios";

function Advertisements() {
  const [arrBanners, setArrBanners] = useState([]);

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`
      const response = await axios.get(url, {headers: {
        Authorization: process.env.REACT_APP_PUBLIC_KEY
      }});

      const banners = response.data.data.filter(item => item.type === "banner");

      setArrBanners(banners)
      console.log(banners);
    } catch (error) {
      console.log(error);
    }
  }

  return(
    <>
      <div className='ads-content'>
        <div className='ad-content'>
          {arrBanners.length > 0 && (
            <ViewQuillComponent content={JSON.parse(arrBanners[0].text_es.content)} type="json" />
          )}
        </div>
        <div className='ad-content'>
          {arrBanners.length > 1 ? (
            <ViewQuillComponent content={JSON.parse(arrBanners[1].text_es.content)} type="json" />
          ) : null}
        </div>
      </div>
    </>
  )
}

export default Advertisements;